import styles from './ForgotPassPage.module.scss';
import contry from '../../../../assets/images/kuwait-flag.png';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { fortgotPassActions } from '../../../../stores/_actions';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';

function ForgotPassPage(props) {
  const { location } = props;
  const jsonData = localStorage.getItem('customer');
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const customerCode = localStorage.getItem('CustomerCode');
  const customer = JSON.parse(jsonData);
  const history = useHistory();

  const [submitted, setSubmitted] = useState(false);
  const [pass, setPin] = useState({
    MPIN: '',
  });

  const menu = {
    beneficiary: false,
    amount: false,
    payment: false,
    confirm: true,
    transfer: false,
    print: false,
  };
  const menuValue = {
    ...location.state,
    menu,
  };

  if (!sessionId) {
    history.goBack();
  }
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      IDNO: customer?.IDNO,
      Mobileno: customer?.MobileNo,
      // CustomerCode: JSON.parse(customerCode),
      // Module: 'ForPASS',
      DeviceID: customer?.IDNO,
      DeviceType: 'WEB',
      Module: 'ForPin',
    },
    Status: false,
    SessionID: customer?.SessionID,
    IdType: null,
  };

  const logging = useSelector((state) => state);
  // const loggingIn = useSelector((state) => state.authentication.loggingIn);
  const dispatch = useDispatch();
  let errorMsg = '';
  let errorMsgIdno = '';
  const handleChange = (e) => {
    // setPin((pass) => ({ ...pass, errorMsg: '' }));
    // setPin((pass) => ({ ...pass, errorMsgIdno: '' }));
    const { name, value } = e.target;
    if (name == 'IDNO') {
      const checkValidpass = Validator.digitsOnly(value);
      if (!checkValidpass) {
        errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
        setPin((pass) => ({ ...pass, [name]: value }));
        setPin((pass) => ({ ...pass, errorMsgIdno: errorMsgIdno }));
        return;
      }
    }
    if (name == 'MobileNo') {
      if (value.length > 8) return;
      setPin((mpin) => ({ ...mpin, errorMsg: '' }));
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber) {
        errorMsg = 'Mobile Number should be Numeric';
        setPin((pass) => ({ ...pass, [name]: value }));
        setPin((pass) => ({ ...pass, errorMsg: errorMsg }));
        return;
      }
      pass.prevMobNo = value;
      pass.MobileNo = value;
      setPin((pass) => ({ ...pass, [name]: value }));
    }
    // if (name == 'IDNO') {
    //   const checkNumber = Validator.digitsOnly(value);
    //   if (!checkNumber) {
    //     errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
    //     setPin((pass) => ({ ...pass, [name]: pass.prevIDNo }));
    //     setPin((pass) => ({ ...pass, errorMsgIdno: errorMsgIdno }));
    //     return;
    //   }
    //   pass.prevIDNo = value;
    //   pass.IDNO = value;
    //   setPin((pass) => ({ ...pass, [name]: value }));
    // }
    setPin((pass) => ({ ...pass, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setPin((pass) => ({ ...pass, errorMsg: '' }));
    setPin((pass) => ({ ...pass, errorMsgIdno: '' }));
    const checkNumber = Validator.digitsOnly(pass.MobileNo);
    let error = false;
    if (!pass.MobileNo) {
      setPin((pass) => ({ ...pass, errorMsg: 'Please enter Mobile Number' }));
      error = true;
    } else if (!checkNumber) {
      errorMsg = 'Mobile Number should be Numeric';
      setPin((pass) => ({ ...pass, errorMsg: errorMsg }));
      error = true;
    } else if (pass.MobileNo.length < 8) {
      setPin((pass) => ({ ...pass, errorMsg: 'Please enter 8 digit valid Mobile Number' }));
      error = true;
    }
    const checkIDNumber = Validator.digitsOnly(pass.IDNO);
    if (!pass.IDNO) {
      setPin((pass) => ({ ...pass, errorMsgIdno: 'Please enter KUWAIT CIVIL ID Number' }));
      error = true;
    } else if (!checkIDNumber) {
      errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
      setPin((pass) => ({ ...pass, errorMsgIdno: errorMsgIdno }));
      error = true;
    } else if (pass.IDNO.length < 12) {
      setPin((pass) => ({ ...pass, errorMsgIdno: 'Please enter 12 digit valid KUWAIT CIVIL ID Number' }));
      error = true;
    }
    if (error) {
      return;
    }
    if (pass.MobileNo && pass.IDNO) {
      payload.Data['IDNO'] = pass.IDNO;
      payload.Data['DeviceID'] = pass.IDNO;
      payload.Data['Mobileno'] = Label.Register.mobileCountryCode + pass.MobileNo;
      dispatch(fortgotPassActions.forgotPass(payload, menuValue));
    }
  };

  let forgotPasswordData;
  useSelector((state) => {
    forgotPasswordData = state.forgotPass?.data;
  }, []);

  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.ForgotPass.heading}</h1>
          <form name="pass" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>Mobile Number</label>
              <input
                type="text"
                name="MobileNo"
                autoComplete="off"
                maxLength="8"
                value={pass?.MobileNo}
                onChange={handleChange}
                className={styles.contrycode}
              />
              <div className={styles.dropdown}>
                <button type="button">
                  <img src={contry} />+{Label.Register.mobileCountryCode}
                </button>
                <div className={styles.dropdown__droppop}>
                  <a href="#">item</a>
                </div>
              </div>
              <div className={styles.formgroup__error}>{pass.errorMsg}</div>
              {/* {submitted && !pass.MobileNo && <div className={styles.formgroup__error}>Please enter Mobile Number</div>} */}
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Register.qatarIdNumber}</label>
              <input type="text" name="IDNO" autoComplete="off" value={pass.IDNO} maxLength="12" onChange={handleChange} />
              <div className={styles.formgroup__error}>{pass.errorMsgIdno}</div>
              {/* {submitted && !pass.IDNO && <div className={styles.formgroup__error}>KUWAIT CIVIL ID Number is required</div>} */}
            </div>

            <Link to={{ pathname: '/transfer', state: menuValue }}>
              <input type="button" value="Back" className={styles.LoginPage__link} style={{ width: '25%', marginRight: '10px' }} />
            </Link>
            <input type="submit" value={Label.ForgotPass.buttonLabel} className={styles.LoginPage__link} style={{ width: '25%' }} />
            {forgotPasswordData != undefined && forgotPasswordData.statusCode !== '200' ? (
              <div className={styles.formgroup__error}>
                <h5>{forgotPasswordData.message}</h5>
              </div>
            ) : (
              ''
            )}
          </form>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { ForgotPassPage };
